import { EmailDomainType, EmailProvider } from '@otter-ai/telemetry';

/** Utility function to retrieve environment configurations for telemetry */
export function getAnalyticsConfig() {
  return {
    app: { id: 'otter-web-purchase' },
    amplitude: {
      enabled: process.env.NEXT_PUBLIC_AMPLITUDE_ENABLED === 'true',
      key: process.env.NEXT_PUBLIC_AMPLITUDE_KEY as string,
    },
    rudderStack: {
      enabled: true,
      key: process.env.NEXT_PUBLIC_RUDDERSTACK_KEY as string,
      configUrl: process.env.NEXT_PUBLIC_RUDDERSTACK_CONFIG_URL as string,
      internalDataPlanUrl: process.env
        .NEXT_PUBLIC_RUDDERSTACK_DATA_PLAN_URL as string,
      pluginsSDKBaseURL: process.env
        .NEXT_PUBLIC_RUDDERSTACK_PLUGINS_SDK_BASE_URL as string,
      destSDKBaseURL: process.env
        .NEXT_PUBLIC_RUDDERSTACK_DEST_SDK_BASE_URL as string,
    },
    statSig: {
      enabled: true,
      key: process.env.NEXT_PUBLIC_STATSIG_KEY as string,
      proxy: process.env.NEXT_PUBLIC_STATSIG_PROXY as string,
      environmentTier: process.env.NEXT_PUBLIC_STATSIG_ENV_TIER as string,
    },
    braze: {
      enabled: process.env.NEXT_PUBLIC_BRAZE_ENABLED === 'true',
      apiKey: process.env.NEXT_PUBLIC_BRAZE_API_KEY as string,
      sdkEndpoint: process.env.NEXT_PUBLIC_BRAZE_SDK_ENDPOINT as string,
      domain: process.env.NEXT_PUBLIC_BRAZE_DOMAIN as string,
      enableLogging: process.env.NEXT_PUBLIC_BRAZE_ENABLE_LOGGING === 'true',
      pushNotificationDomain: process.env
        .NEXT_PUBLIC_BRAZE_PUSH_NOTIFICATION_DOMAIN as string,
    },
    googleAnalytics: {
      enabled: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ENABLED === 'true',
      key: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_KEY as string,
    },
    googleTagManager: {
      enabled: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ENABLED === 'true',
      key: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_KEY as string,
    },
    sprig: {
      enabled: process.env.NEXT_PUBLIC_SPRIG_ENABLED === 'true',
    },
    tatari: {
      enabled: process.env.NEXT_PUBLIC_TATARI_ENABLED === 'true',
      url: process.env.NEXT_PUBLIC_TATARI_URL as string,
      key: process.env.NEXT_PUBLIC_TATARI_KEY as string,
    },
    oneTrust: {
      enabled:
        process.env.NEXT_PUBLIC_ONETRUST_ENABLED === 'true' &&
        process.env.NODE_ENV !== 'development',
      scriptId: process.env.NEXT_PUBLIC_ONETRUST_SCRIPT_ID as string,
    },
    openTelemetry: {
      enabled: process.env.NEXT_PUBLIC_OPENTELEMETRY_ENABLED === 'true',
      token: {
        endpoint: process.env
          .NEXT_PUBLIC_OPENTELEMETRY_TOKEN_ENDPOINT as string,
      },
      environmentTier: process.env.NEXT_PUBLIC_OPENTELEMETRY_ENV_TIER as string,
      collectorEndpoint: process.env
        .NEXT_PUBLIC_OPENTELEMETRY_COLLECTOR_ENDPOINT as string,
    },
    fingerprint: {
      enabled: process.env.NEXT_PUBLIC_FINGERPRINT_ENABLED === 'true',
    },
    ingestLogs: {
      url: process.env.NEXT_PUBLIC_INGEST_LOGS_URL as string,
    },
    production: process.env.NODE_ENV === 'production',
    version: {
      // todo (winfred): get the version from the package.json
      number: '1.0.0',
    },
  };
}

/** Determines the email domain type based on API-assigned label */
export function emailDomainLabelToDomainType(
  domainLabel?: string,
): EmailDomainType | null {
  if (!domainLabel) return null;
  switch (domainLabel) {
    case 'work':
      return EmailDomainType.work;
    case 'personal':
      return EmailDomainType.personal;
    case 'edu':
      return EmailDomainType.edu;
    default:
      return EmailDomainType.unknown;
  }
}

/** Determines the email provider type based on host label from API */
export function emailHostToProviderType(
  emailHost?: string | null,
): EmailProvider | null {
  if (!emailHost) return null;
  switch (emailHost) {
    case 'google':
      return EmailProvider.Google;
    case 'microsoft':
      return EmailProvider.Microsoft;
    default:
      return EmailProvider.Other;
  }
}
